import { useTranslation } from 'next-i18next'
import React from 'react'

import Star from '../../assets/star.inline.svg'
import StarYellow from '../../assets/starYellow.inline.svg'
import { Icon } from '../icon'

import styles from './reviewHighLightsSection.module.scss'
import stylesV2 from './reviewHighlightsSectionV2.module.scss'
export interface ReviewHighlightsSummaryProps {
  averageRating?: number
  reviewCount?: number
  showReviewSection: () => void
  newPdpv2?: boolean
}

const ReviewHighlightsSummary = ({
  averageRating,
  reviewCount,
  showReviewSection,
  newPdpv2,
}: ReviewHighlightsSummaryProps) => {
  const { t } = useTranslation('common')
  const finalStyles = newPdpv2 ? stylesV2 : styles
  return newPdpv2 ? (
    <div className={finalStyles.reviewHighlightDetails}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Icon key={index} iconSvg={StarYellow} className={finalStyles.reviewHighlightDetails__starIcon} />
      ))}
      <span className={finalStyles.reviewHighlightDetails__averageRating}>{averageRating}</span>
      <span>{'('}</span>
      <span
        role="button"
        tabIndex={0}
        onClick={showReviewSection}
        className={finalStyles.reviewHighlightDetails__reviewCountLink}
      >
        {reviewCount}
      </span>
      <span>{')'}</span>
    </div>
  ) : (
    <div className={finalStyles.reviewHighlightDetails}>
      <Icon iconSvg={Star} className={finalStyles.reviewHighlightDetails__starIcon} />
      <span>{averageRating}</span>
      <span className={finalStyles.reviewHighlightDetails__separator}>|</span>
      <span
        role="button"
        tabIndex={0}
        onClick={showReviewSection}
        className={finalStyles.reviewHighlightDetails__reviewCountLink}
      >
        {reviewCount} {t('reviews_v1')}
      </span>
    </div>
  )
}

export default ReviewHighlightsSummary
